import axios from 'axios';

export const getCategories = async () => {
    try {
    const apiUrl = `${process.env.REACT_APP_PUBLIC_API}/categories?parent=1&order[sort]=asc`;
        
        const response = await axios.get(apiUrl, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            withCredentials: false
        });
        
        if (!response.data || !Array.isArray(response.data)) {
            console.error('Format de réponse invalide:', response.data);
            throw new Error('Format de réponse invalide');
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur lors du chargement des catégories:', error);
        if (error.response) {
            console.error('Réponse du serveur:', error.response.data);
            console.error('Status:', error.response.status);
        } else if (error.request) {
            console.error('Pas de réponse du serveur');
        } else {
            console.error('Erreur de configuration:', error.message);
        }
        throw error;
    }
}

